import { ProfileButton } from "./ProfileButton";
import LetterIcon from "../Icons/LetterIcon";

export function MailButton(props) {
  return (
    <ProfileButton 
      classList="profile-button__mail"
      icon={<LetterIcon />}
      {...props}
    >
      Sending letters/packages FAQs
    </ProfileButton>
  );
}

export default MailButton;